import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import Role from "../helpers/role";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import * as moment from "moment";
import { Translation } from "react-i18next";
import FileSaver from "file-saver";
import Moment from "moment";
import axios from "axios";
import API from "../helpers/api";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-multi-email/style.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { getShipManagementDetails } from "../Actions/ShipManagementAPI";
import { getEquipmentCyclingServiceYear } from "../Actions/EquipmentManagementAPI";
import $ from "jquery";
import { getShipDeatil } from "../Actions/ShipEquipmentDetailsAPI";
import { ControlPointDuplicateOutlined } from "@material-ui/icons";

let userrole = localStorage.getItem("UserRoles");

class EquipmentUpdateListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFile: false,
      break: false,
      panel_break: false,
      isDuplicate: false,
      isNewBudget: false,
      isShore: false,
      isShip: false,
      modalIsOpen: false,
      isContractPopover:false,
      isbothContract:true,
      isContract:false,
      isNotContract:false,
      isContractFilterApply:false,
      contractmodalIsOpen: false,
      isWorldWide: [],
      Budgetable: [],
      Compliancetable: [],
      ComplianceApplicableYears: [],
      SelectedYear: "",
      isShipType:false,
      isShoreType:false,
      isBothType:false,
      isFilterApply:false,
    };
  }

  async componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch({
      type: "SubBannerTitle",
      data: "Equipment Service Details List",
    });
    const Id = parseInt(match.params.id);
    this.getEquipmentServiceList(Id);
    window.addEventListener("resize", this.resize.bind(this));
    window.addEventListener("resize", this.panelresize.bind(this));
    console.log("componentDidMount");
    this.resize();
    this.panelresize();
  }
  handleShipTypeChange = (e) => {
    if (e.target.checked) {
      if($(".check-open").hasClass("is-visible")){
        var selectArray= $(".is-visible").text()
        var strx   = selectArray.split('yearly');
        var array  = [];
        array = array.concat(strx)
        array.map((item, index) => {
          if(item.match(/\./g))
          {
          let str=item.replace(".","");
          $(`.showdate #date${str}`).addClass("d-none");
          $(`#show${str}`).addClass("d-none");
          $(`#visible${str}`).removeClass("is-visible");
          $(`#hide${str}`).removeClass("d-none");
        }
        else{
          $(`.showdate #date${item}`).addClass("d-none");
          $(`#show${item}`).addClass("d-none");
          $(`#visible${item}`).removeClass("is-visible");
          $(`#hide${item}`).removeClass("d-none");
        }
        })
          }
    this.state.isShipType=true;
    }else{
      if($(".check-open").hasClass("is-visible")){
        var selectArray= $(".is-visible").text()
        var strx   = selectArray.split('yearly');
        var array  = [];
        array = array.concat(strx)
        array.map((item, index) => {
          if(item.match(/\./g))
          {
          let str=item.replace(".","");
          $(`.showdate #date${str}`).addClass("d-none");
          $(`#show${str}`).addClass("d-none");
          $(`#visible${str}`).removeClass("is-visible");
          $(`#hide${str}`).removeClass("d-none");
        }
        else{
          $(`.showdate #date${item}`).addClass("d-none");
          $(`#show${item}`).addClass("d-none");
          $(`#visible${item}`).removeClass("is-visible");
          $(`#hide${item}`).removeClass("d-none");
        }
        })
          }
      this.state.isShipType=false;
    }
    if(this.state.isShipType===true||this.state.isBothType===true||this.state.isShoreType===true){
      this.state.isFilterApply=true;
    }else if(this.state.isShipType===false&&this.state.isBothType===false&&this.state.isShoreType===false){
      this.state.isFilterApply=false;
    }
    this.setState({});
  };
  handleShoreTypeChange = (e) => {
    if (e.target.checked) {
      if($(".check-open").hasClass("is-visible")){
      var selectArray= $(".is-visible").text()
      var strx   = selectArray.split('yearly');
      var array  = [];
      array = array.concat(strx)
      array.map((item, index) => {
        if(item.match(/\./g))
        {
        let str=item.replace(".","");
        $(`.showdate #date${str}`).addClass("d-none");
        $(`#show${str}`).addClass("d-none");
        $(`#visible${str}`).removeClass("is-visible");
        $(`#hide${str}`).removeClass("d-none");
      }else{
        $(`.showdate #date${item}`).addClass("d-none");
        $(`#show${item}`).addClass("d-none");
        $(`#visible${item}`).removeClass("is-visible");
        $(`#hide${item}`).removeClass("d-none");
      }
      })
        }
    this.state.isShoreType=true;
    }else{
      this.state.isShoreType=false;
      if($(".check-open").hasClass("is-visible")){
        var selectArray= $(".is-visible").text()
        var strx   = selectArray.split('yearly');
        var array  = [];
        array = array.concat(strx)
        array.map((item, index) => {
          if(item.match(/\./g))
          {
          let str=item.replace(".","");
          $(`.showdate #date${str}`).addClass("d-none");
          $(`#show${str}`).addClass("d-none");
          $(`#visible${str}`).removeClass("is-visible");
          $(`#hide${str}`).removeClass("d-none");
        }else{
          $(`.showdate #date${item}`).addClass("d-none");
          $(`#show${item}`).addClass("d-none");
          $(`#visible${item}`).removeClass("is-visible");
          $(`#hide${item}`).removeClass("d-none");
        }
        })
          }
    }
    if(this.state.isShipType===true||this.state.isBothType===true||this.state.isShoreType===true){
      this.state.isFilterApply=true;
    }else if(this.state.isShipType===false&&this.state.isBothType===false&&this.state.isShoreType===false){
      this.state.isFilterApply=false;
    }
    this.setState({});
  };
  handleBothTypeChange = (e) => {
    if (e.target.checked) {
      if($(".check-open").hasClass("is-visible")){
        var selectArray= $(".is-visible").text()
        var strx   = selectArray.split('yearly');
        var array  = [];
        array = array.concat(strx)
        array.map((item, index) => {
          if(item.match(/\./g))
          {
          let str=item.replace(".","");
          $(`.showdate #date${str}`).addClass("d-none");
          $(`#show${str}`).addClass("d-none");
          $(`#visible${str}`).removeClass("is-visible");
          $(`#hide${str}`).removeClass("d-none");
        }
        else{
          $(`.showdate #date${item}`).addClass("d-none");
          $(`#show${item}`).addClass("d-none");
          $(`#visible${item}`).removeClass("is-visible");
          $(`#hide${item}`).removeClass("d-none");
        }
        })
          }
      this.state.isShipType=true;
      this.state.isShoreType=true;
    this.state.isBothType=true;
   }else{
    if($(".check-open").hasClass("is-visible")){
      var selectArray= $(".is-visible").text()
      var strx   = selectArray.split('yearly');
      var array  = [];
      array = array.concat(strx)
      array.map((item, index) => {
        if(item.match(/\./g))
        {
        let str=item.replace(".","");
        $(`.showdate #date${str}`).addClass("d-none");
        $(`#show${str}`).addClass("d-none");
        $(`#visible${str}`).removeClass("is-visible");
        $(`#hide${str}`).removeClass("d-none");
      }
      else{
        $(`.showdate #date${item}`).addClass("d-none");
        $(`#show${item}`).addClass("d-none");
        $(`#visible${item}`).removeClass("is-visible");
        $(`#hide${item}`).removeClass("d-none");
      }
      })
        }
      this.state.isShipType=false;
      this.state.isShoreType=false;
      this.state.isBothType=false;
    }
    if(this.state.isShipType===true||this.state.isBothType===true||this.state.isShoreType===true){
      this.state.isFilterApply=true;
    }else if(this.state.isShipType===false&&this.state.isBothType===false&&this.state.isShoreType===false){
      this.state.isFilterApply=false;
    }
    this.setState({});
  };
  toggle = (target, item) => {
    this.setState({
      [target]: !this.state[target],
      ship: false,
      shore: false,
      both: false,
    });
  };

 /* Equipment Filter function */
 handleEquipmentCotractChange=(e)=>{
  const { dispatch, match } = this.props;
  const Id = parseInt(match.params.id);
  if(e.target.checked){
    this.state.isContract=true;
  }else{
    this.state.isContract=false;
  }
  if(this.state.isContract===true || this.state.isNotContract===true){
    this.state.isbothContract=false;
  }
  if(this.state.isContract===true && this.state.isNotContract===true||this.state.isContract===false && this.state.isNotContract===false){
    this.state.isbothContract=true;
  }
if(this.state.isContract===true||this.state.isNotContract===true){
    this.state.isContractFilterApply=true;
  }else if(this.state.isContract===false&&this.state.isNotContract===false){
    this.state.isContractFilterApply=false;
  }
  this.state.isContractPopover=!this.state.isContractPopover;
  this.setState({},()=>{
    this.getEquipmentComplianceList(Id,this.state.SelectedYear,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
  });
}

handleNotEquipmentContractChange=(e)=>{
const { dispatch, match } = this.props;
const Id = parseInt(match.params.id);
if (e.target.checked) {
 this.state.isNotContract=true;
}else{
  this.state.isNotContract=false;
}
 if(this.state.isContract===true||this.state.isNotContract===true){
    this.state.isContractFilterApply=true;
  }else if(this.state.isContract===false&&this.state.isNotContract===false){
    this.state.isContractFilterApply=false;
  }
  if(this.state.isContract===true || this.state.isNotContract===true){
    this.state.isbothContract=false;
  }
  if(this.state.isContract===true && this.state.isNotContract===true||this.state.isContract===false && this.state.isNotContract===false){
    this.state.isbothContract=true;
  }
  this.state.isContractPopover=!this.state.isContractPopover;
  this.setState({},()=>{
    this.getEquipmentComplianceList(Id,this.state.SelectedYear,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
   
  });
}
Contracttoggle = () => {
 this.state.isContract=this.state.isContract;
this.state.isNotContract=this.state.isNotContract;
this.state.isContractPopover= !this.state.isContractPopover;
  this.setState({
   
   });
};

  resize() {
    if (window.innerWidth < 455) {
      this.setState({
        break: true,
      });
    } else {
      this.setState({
        break: false,
      });
    }
  }
  panelresize() {
    if (window.innerWidth < 1000) {
      this.setState({
        panel_break: true,
      });
    } else {
      this.setState({
        panel_break: false,
      });
    }
  }

  getEquipmentServiceList = (shipId) => {
    const { dispatch, match } = this.props;
    let url = `${API.getEquipmentCycleYear}?shipId=${shipId}`;
    axios.get(url).then((response) => {
      let Max = [];
      let serviceTypeList = [];
      let FinalMax="";
      response.data.map((item, index) => {
        dispatch(showLoader());
        let listItem1 = item.split("-");
        let order = listItem1[0].substring(listItem1[0].lastIndexOf("/") + 1);
        let order1 = listItem1[1].substring(listItem1[1].lastIndexOf("/") + 1);
        let finalyear = order + " - " + order1;
        let range = item;
        serviceTypeList.push({
          range,
          finalyear,
        });
      });
     serviceTypeList.map((item)=>{
       let result=item.finalyear.split("-");
       let result1 = result[1];
       Max.push(result1);
       FinalMax = Math.max(...Max.map(item => item));
      console.log(FinalMax)
     })
     serviceTypeList.map((item)=>{
      let result=item.finalyear.split("-");
      let result1 = result[1];
      let FinalYear=parseInt(result1)
      const Id = parseInt(match.params.id);
     if( FinalYear===FinalMax){
       let year=item.range;
       console.log("year",year)
      this.setState(
        {
          SelectedYear: year
        },
        () => {
          this.getShipDetailsList(Id)
        }
      );
     }
     })
      dispatch({
        type: "getEquipmentCyclingServiceYearSuccess",
        data: serviceTypeList,
      });
    });
  };
  getShipDetailsList=(shipId)=>{
    const { dispatch } = this.props;
    let url = `${API.ShipDetail}?shipId=${shipId}`;
      axios
        .get(url)
        .then((response) => {
          if(response.status===200){
            dispatch(showLoader());
            dispatch({
              type: "GetShipDetailSuccess",
              data: response.data,
            });
            this.getEquipmentComplianceList(shipId, this.state.SelectedYear,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
          }
         
        })
        .catch((error) => {
          dispatch({
            type: "GetShipDetailFailure",
            error: "ERROR",
          });
        });
    
  }

  getEquipmentComplianceList = (id, yearId,iscontract,isnotcontract,isboth) => {
    const { dispatch } = this.props;
    dispatch(showLoader());
     let url = `${API.getComplianceStatus}?shipId=${id}&serviceRange=${yearId}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
    axios
      .get(url)
      .then((response) => {
    if (response.status === 200) { 
       this.state.Compliancetable = response.data;
       this.state.ComplianceApplicableYears = response.data.applicableService ;
       this.setState({});

    // dispatch(getEquipmentCyclingServiceYear(id))
        }
      })
      .catch((error) => {}); 
  };

  renderPopoverTick(array, ApplicableTypes, Type) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
        {ApplicableTypes.shipServiceYears.length !== 0 ? (
          ApplicableTypes?.shipServiceYears?.filter(
            (item) => item?.year === array)[0]?.nextDueDate!==null?
            <label style={{ padding: "0px 10px" }}>
              { t("UpdateList.NextServiceDueDate") + " "+
                 moment(ApplicableTypes?.shipServiceYears?.filter(
                    (item) => item?.year === array)[0]?.nextDueDate).format("DD MMM YYYY")}
            </label>:<label></label>
          ) : (
            ""
          )}
        </Popovers.Content>
      </Popovers>
    );
  }
 renderPopoverTickShore(array, ApplicableTypes, Type) {
  const {t}=this.props;
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          {ApplicableTypes.shoreServiceYears.length !== 0 ? (
              ApplicableTypes?.shoreServiceYears?.filter(
              (item) => item?.year === array)[0]?.nextDueDate !==null?
            <label style={{ padding: "0px 10px" }}>
              { t("UpdateList.NextServiceDueDate") + " "+
           moment(ApplicableTypes?.shoreServiceYears?.filter(
                    (item) => item?.year === array)[0]?.nextDueDate).format("DD MMM YYYY")}
            </label>:
            <label></label>
          ) : (
            ""
          )}
         
        </Popovers.Content>
      </Popovers>
    );
  } 
  rendernextduedateover(props) {
    const {t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("UpdateList.Shownextduedate")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  rendernextduedateover1(props) {
    const {t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("UpdateList.Hidenextduedate")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }
nextServiceDateVisible(e,searviceYear){
let id=searviceYear.split(" ")[0]
if(id.match(/\./g)){
  let str=id.replace(".","")
  console.log(str)
$(`.showdate #date${str}`).removeClass("d-none");
$(`#show${str}`).removeClass("d-none");
$(`#visible${str}`).addClass("is-visible");
$(`#hide${str}`).addClass("d-none");
}else{
  $(`.showdate #date${id}`).removeClass("d-none");
  $(`#show${id}`).removeClass("d-none");
  $(`#visible${id}`).addClass("is-visible");
  $(`#hide${id}`).addClass("d-none");
}

}
nextServiceDateHide(e,searviceYear){
let id=searviceYear.split(" ")[0]
if(id.match(/\./g)){
  let str=id.replace(".","")
  console.log(str)
  $(`.showdate #date${str}`).addClass("d-none");
  $(`#show${str}`).addClass("d-none");
  $(`#visible${str}`).removeClass("is-visible");
  $(`#hide${str}`).removeClass("d-none");
}
else{
$(`.showdate #date${id}`).addClass("d-none");
$(`#show${id}`).addClass("d-none");
$(`#visible${id}`).removeClass("is-visible");
$(`#hide${id}`).removeClass("d-none");
}
 
}

  toggleVisibiliti = () => {
    this.setState((prevState) => ({ isFile: !this.state.isFile }));
  };
  hideSidePanel = () => {
    this.props.dispatch({ type: "searched", data: true });
    this.props.dispatch({ type: "MapPopup", data: 0 });
    this.props.dispatch({ type: "ShowSidePan", data:false });
    this.props.history.goBack();
  };
  render() {
    return <div className="pb-3">{this.renderCardData()}</div>;
  }
  handleInputChange(e) {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({}, () => {
      this.getEquipmentComplianceList(Id,this.state.SelectedYear,this.state.isContract,this.state.isNotContract,this.state.isbothContract);
    });
  }
/* Export excel function */
ExportExcel = (shipName,iscontract,isnotcontract,isboth) => {
  const { dispatch, match } = this.props;
  const Id = parseInt(match.params.id);
  let ServiceRange=this.state.SelectedYear;
  let url = `${API.DownloadEquipmentServiceDetails}?shipId=${Id}&serviceRange=${ServiceRange}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
 axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        let FileName = "Equipment Details"+" "+shipName +"_" + moment().format("DD MM YYYY LT") + ".xlsx";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, FileName);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };

  editEquipmentDetails = (shipEquipmentId) => {
    const { dispatch, match } = this.props;
    const shipId = parseInt(match.params.id);
    this.props.history.push(`/Home/EquipmentServiceTypes/${shipId}/${shipEquipmentId}`);
  };
    renderCardData() {
    const { EquipmentZoneList, shipDetail, ShipEquipmentServiceYear,t } = this.props;
    const { Compliancetable, ComplianceApplicableYears } = this.state;
    console.log("zone");
    var ServeData = EquipmentZoneList;
    console.log("serve", ServeData);

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
            onClick={() => this.hideSidePanel()}
          >
            &larr; {t("CommonText.Back")}
          </button>
            <div className="col-lg-12">
              <div className="row resource-list-auth-date">
                <div className="col-lg-12">
                  <div className="panel-box search-filter-box">
                    <div className="row">
                      <div className="col-lg-6">
                        <span className="mt-1">
                          <strong style={{ fontSize: "larger" }}>
                          {t("content.Shipname")}:{" "}
                          </strong>
                          <span className="lato">
                            {shipDetail.shipName ? shipDetail.shipName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-lg-6">
                        <span className="mt-1">
                          <strong style={{ fontSize: "larger" }}>
                          {t("EquipmentSeviceDetailsScreen.EnrollmentDate")} :{" "}
                          </strong>
                          <span className="lato">
                            {shipDetail.enrollmentDate
                              ? Moment(
                                  new Date(
                                    Date.parse(shipDetail.enrollmentDate)
                                  )
                                ).format("DD MMM YYYY")
                              : ""}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div
                      className="card MM-card-header mb-0 mt-3"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}>
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }} >
                        {t("content.EquipmentServiceDetailsScreen")}
                        </h5>
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className="col-lg-12 col-sm-12 col-md-12">
                        <div className="px-4">
                         <div className="col-lg-4 col-sm-4 col-md-4">
                            <label className="form-label"> {t("EquipmentSeviceDetailsScreen.ServiceYear")}</label>
                            <br></br>
                            <select
                              className="form-control"
                              name="SelectedYear"
                              value={this.state.SelectedYear}
                              onChange={(e) => this.handleInputChange(e)}>
                              <option value="">{t("ClassScreen.SelectServiceYear")}</option>
                              {ShipEquipmentServiceYear &&
                                ShipEquipmentServiceYear.map((year) => (
                                  <option value={year.range}> {year.finalyear} </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box pb-3">
                      <div className="row px-4">
                        <div className="col-12 px-4 pt-2 mt-1">
                          <div
                            className="table-responsive"
                            style={{ width: "100%" }}>
                            <table className="table cellborder">
                              <thead>
                                <tr className="table-active section-color border">
                                  <th
                                    className={`${window.innerWidth < 1000 ? " " : "sl-no"}
                                  border-right border-top text-center border-left border-bottom Service-equipment-width plan-color`}>
                                    {" "}
                                    {t("ComplianceandBudgetScreen.Equipments")}
                                    <i class={`fa fa-filter click ml-2 cursor-pointer text-right showhideicon filter-style ${this.state.isContractFilterApply? "filterApplyColor":" "}`}  id="popovernew"></i>
                                 <Popover 
                             placement="right"
                             className="popover-equip"
                             trigger="legacy"
                             isOpen={this.state.isContractPopover}
                             target={"popovernew"}
                             toggle={() => this.Contracttoggle(`popovernew`)}>
                            <PopoverHeader>
                            {t("UpdateList.ContractEquipmentSearch")}
                            </PopoverHeader>
                            <PopoverBody>
                              <div className="row">
                                <div className="col-6 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style"
                                    checked={this.state.isContract}
                                    onChange={(e) =>this.handleEquipmentCotractChange(e)} />
                                  <span className="ml-2" style={{marginTop:"2px"}}>{t("ContractContent.IsContract")}</span>
                                </div>
                                <div className="col-6 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style-shore"
                                    checked={this.state.isNotContract}
                                    onChange={(e) =>
                                      this.handleNotEquipmentContractChange(e)
                                    }/>
                                  <span className="ml-1" style={{marginTop:"2px"}}>{t("ContractContent.NotContract")}</span>
                                </div>
                          
                                </div>
                            </PopoverBody>
                                  </Popover>
                                  </th>
                                  <th
                                    className={`${
                                      window.innerWidth < 1000 ? " " : "Service-tr-title" }
                                  border-right border-top text-center border-left Service-type-width plan-color`}>
                                    {t("ComplianceandBudgetScreen.Qty")}{" "}
                                  </th>
                                  <th
                                    className={`${
                                      window.innerWidth < 1000
                                        ? " "
                                        : "Service-type-title" }
                                    border-right border-top text-center border-left Service-type-width plan-color`}
                                    scope="col">
                                    {t("ComplianceandBudgetScreen.Type")}{" "}
                                    <i
                                    class={`fa fa-filter click ml-2 text-right showhideicon filter-style ${this.state.isFilterApply?"filterApplyColor":" "}`}  id="popover"></i>
                            <Popover 
                             placement="right"
                             trigger="legacy"
                             isOpen={this.state.popover}
                             target={"popover"}
                             toggle={() => this.toggle(`popover`)}>
                            <PopoverHeader>
                            {t("UpdateList.EquipmentServiceType")} 
                            </PopoverHeader>
                            <PopoverBody>
                              <div className="row">
                                <div className="col-4 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style"
                                    checked={this.state.isShipType}
                                    disabled={this.state.isBothType}
                                    onChange={(e) =>
                                      this.handleShipTypeChange(e)
                                    }
                                  />
                                  <span className="ml-2" style={{marginTop:"2px"}}>{t("Generateservicerequestcontent.Ship")}</span>
                                </div>
                                <div className="col-4 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style-shore"
                                    checked={this.state.isShoreType}
                                    disabled={this.state.isBothType}
                                    onChange={(e) =>
                                      this.handleShoreTypeChange(e)
                                    }/>
                                  <span className="ml-1" style={{marginTop:"2px"}}>{t("Generateservicerequestcontent.Shore")}</span>
                                </div>
                                <div className="col-4 my-1 popover-style">
                                  <input
                                    type="checkbox"
                                    className="popover-checkbox-style"
                                    checked={this.state.isBothType}
                                    onChange={(e) =>
                                      this.handleBothTypeChange(e)
                                    }/>
                                  <span className="ml-2" style={{marginTop:"2px"}}>{t("Generateservicerequestcontent.Both")}</span>
                                </div>
                                </div>
                            </PopoverBody>
                          </Popover>
                       </th>
                                  {ComplianceApplicableYears?.map(
                                    (i, index) => (
                                      <th
                                        className="border-right border-top text-center border-left Service-year-width plan-color"
                                        scope="col">
                                       <span className="text-left check-open" id={"visible"+i.split(" ")[0].replace(".","")} value={i}>{i}</span> 
                                       <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={this.rendernextduedateover1()}>
                                       <i class="fa fa-eye click ml-2 text-right showhideicon d-none filter-style" id={"show"+i.split(" ")[0].replace(".","")} onClick={(e)=>this.nextServiceDateHide(e,i)}></i></OverlayTrigger>
                                       <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={this.rendernextduedateover()}>
                                       <i class="fa fa-eye-slash click ml-2 text-right showhideicon filter-style" id={"hide"+i.split(" ")[0].replace(".","")} onClick={(e)=>this.nextServiceDateVisible(e,i)}></i></OverlayTrigger>
                                       </th>
                                    ))}
                                </tr>
                              </thead>
                              <tbody className="table-body">
                                {/* if service type ship and shore below table will display */}
                              {this.state.isShipType && this.state.isShoreType && !this.state.isBothType || !this.state.isShoreType && !this.state.isShipType && !this.state.isBothType || this.state.isBothType && !this.state.isShipType && !this.state.isShoreType ?
                                Compliancetable?.equipments?.length !==0 ? (Compliancetable?.equipments?.map(
                                    (j, index) => (
                                      <>
                                        <tr className="border-top">
                                          <td
                                            className={`${
                                              window.innerWidth < 1000 ? ""
                                                : "sl-no" }
                                            border-right border-left border-bottom text-center Service-equipment-width align-middle`}
                                           rowSpan={2} >
                                                { userrole == Role.mmpladmin || userrole == Role.mmpl?
                                             <span style={{textDecorationLine:"underline" ,cursor:"pointer"}} className={`spandoc-td ${j?.inContract===true?"ContractColor":""}`} onClick={() =>
                                                this.editEquipmentDetails(j?.shipEquipmentId)}>
                                              {j.equipmentName}
                                            </span>:
                                              <span className={`spandoc-td ${j?.inContract===true?"ContractColor":""}`}>
                                              {j.equipmentName}
                                            </span>}
                                          </td>
                                          <td
                                            className={`${
                                              window.innerWidth < 1000
                                                ? " "
                                                : "Service-tr-title"
                                            }
                                            border-right border-left border-bottom text-center align-middle Service-type-width`}
                                            rowSpan={2}>
                                            {" "}
                                            <span className="spandoc-td">
                                              {j.quantity}
                                            </span>
                                          </td>
                                          <td
                                            className={`${
                                              window.innerWidth < 1000
                                                ? " "
                                                : "Service-type-title"
                                            }
                                          border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                            <span className="spandoc-td">
                                            {t("Generateservicerequestcontent.Ship")}
                                            </span>
                                          </td>
                                          {ComplianceApplicableYears?.map(
                                            (i, index) => (
                                              <td className="border-right text-center border-left border-bottom Service-year-width showdate" >
                                                {" "}
                                                {j?.shipServiceYears?.filter(
                                                  (item) => item?.year === i
                                                )[0]?.year ? (
                                                  <>
                                                    <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400,
                                                    }}
                                                    overlay={this.renderPopoverTick(
                                                      j?.shipServiceYears.filter((item) => item?.year === i)[0]?.year,
                                                      j,
                                                      "ship"
                                                    )}> 
                                                  <i style={{cursor:"pointer"}}
                                                    className={`fa fa-check align-middle text-left ${
                                                      j?.shipServiceYears.filter(
                                                        (item) =>
                                                          item.year === i
                                                      )[0]?.status ===
                                                      "Notupdated"
                                                        ? ` `
                                                        : j?.shipServiceYears.filter(
                                                            (item) =>
                                                              item.year === i
                                                          )[0]?.status ===
                                                          "Updated"
                                                        ? `update-color`
                                                        : j?.shipServiceYears.filter(
                                                            (item) =>
                                                              item.year === i
                                                          )[0]?.status ===
                                                          "Overdue"
                                                        ? `Overdue-color`
                                                        : ``
                                                    }`}
                                                    aria-hidden="true"
                                                  ></i>
                                                </OverlayTrigger>
                                                  <span className="text-right ml-3 d-none" id={"date"+i.split(" ")[0].replace(".","")}>
                                                 { j?.shipServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate!==null?
                                                       moment(j?.shipServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate).format("DD MMM YY"):""}
                                                </span>
                                               </>
                                               ) : (
                                                  // </OverlayTrigger>
                                                  <>
                                                    <i
                                                      className="fa fa-times align-middle"
                                                      aria-hidden="true"
                                                      style={{
                                                        cursor: "default",
                                                      }}
                                                    ></i>
                                                  </>
                                                )}
                                              </td>
                                            )
                                          )}
                                        </tr>
                                         <tr className="border-top">
                                          <td
                                            className={`${
                                              window.innerWidth < 1000
                                                ? " "
                                                : "Service-type-title"
                                            }
                                          border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                            <span className="spandoc-td">
                                            {t("Generateservicerequestcontent.Shore")}
                                            </span>
                                          </td>
                                          {ComplianceApplicableYears?.map(
                                            (i, index) => (
                                              <td className="border-right text-center border-left border-bottom showdate">
                                                {" "}
                                                {j?.shoreServiceYears?.filter(
                                                  (item) => item?.year === i
                                                )[0]?.year ? (
                                                  <>
                                                    <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400,
                                                    }}
                                                    overlay={this.renderPopoverTickShore(
                                                      j?.shoreServiceYears.filter((item) => item?.year === i)[0]?.year,
                                                      j,
                                                      "shore"
                                                    )}
                                                  > 
                                                  <i style={{cursor:"pointer"}}
                                                    className={`fa fa-check align-middle ${
                                                      j?.shoreServiceYears.filter(
                                                        (item) =>
                                                          item.year === i
                                                      )[0]?.status ===
                                                      "Notupdated"
                                                        ? ``
                                                        : j?.shoreServiceYears.filter(
                                                            (item) =>
                                                              item.year === i
                                                          )[0]?.status ===
                                                          "Updated"
                                                        ? `update-color`
                                                        : j?.shoreServiceYears.filter(
                                                            (item) =>
                                                              item.year === i
                                                          )[0]?.status ===
                                                          "Overdue"
                                                        ? `Overdue-color`
                                                        : ``}`}
                                                    aria-hidden="true"></i>
                                                    </OverlayTrigger>
                                                    <span className="text-right ml-3 d-none" id={"date"+i.split(" ")[0].replace(".","")}>
                                                    {j?.shoreServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate !==null?
                                                    moment(j?.shoreServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate).format("DD MMM YY"):""}
                                             </span>
                                             </>
                                                ) : (
                                                  //  </OverlayTrigger>
                                                  <>
                                                    <i
                                                      class="fa fa-times align-middle"
                                                      style={{
                                                        cursor: "default",
                                                      }}
                                                      aria-hidden="true"
                                                    ></i>
                                                  </>
                                                )}
                                              </td>
                                            )
                                          )}
                                        </tr></>))) : (<>
                                    <tr className="border-top">
                                      <td
                                        colSpan={11}
                                        className="text-center border-left border-bottom border-top border-right align-middle">
                                        <span className="spandoc-td">
                                          {" "}
                                          {t("EquipmentSeviceDetailsScreen.NoitemDisplay")}
                                      </span>
                                      </td>
                                    </tr>
                                  </>):
                                  /* if service type is ship below table will display */
                                 this.state.isShipType && !this.state.isShoreType  && !this.state.isBothType?
                                 Compliancetable?.equipments?.length !==0 ? (Compliancetable?.equipments?.map(
                                     (j, index) => (
                                       <>
                                         <tr className="border-top">
                                           <td
                                             className={`${
                                               window.innerWidth < 1000 ? ""
                                                 : "sl-no" }
                                             border-right border-left border-bottom text-center Service-equipment-width align-middle`} >
                                              <span className={`spandoc-td ${j?.inContract===true?"ContractColor":""}`}>
                                               {j.equipmentName}
                                             </span>
                                           </td>
                                           <td
                                             className={`${
                                               window.innerWidth < 1000
                                                 ? " "
                                                 : "Service-tr-title"
                                             }
                                             border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                             {" "}
                                             <span className="spandoc-td">
                                               {j.quantity}
                                             </span>
                                           </td>
                                           <td
                                             className={`${
                                               window.innerWidth < 1000
                                                 ? " "
                                                 : "Service-type-title"
                                             }
                                           border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                             <span className="spandoc-td">
                                             {t("Generateservicerequestcontent.Ship")}
                                             </span>
                                           </td>
                                           {ComplianceApplicableYears?.map(
                                             (i, index) => (
                                               <td className="border-right text-center border-left border-bottom Service-year-width showdate" >
                                                 {" "}
                                                 {j?.shipServiceYears?.filter(
                                                   (item) => item?.year === i
                                                 )[0]?.year ? (
                                                   <>
                                                     <OverlayTrigger
                                                     placement="bottom"
                                                     delay={{
                                                       show: 250,
                                                       hide: 400,
                                                     }}
                                                     overlay={this.renderPopoverTick(
                                                       j?.shipServiceYears.filter((item) => item?.year === i)[0]?.year,
                                                       j,
                                                       "ship"
                                                     )}> 
                                                   <i style={{cursor:"pointer"}}
                                                     className={`fa fa-check align-middle text-left ${
                                                       j?.shipServiceYears.filter(
                                                         (item) =>
                                                           item.year === i
                                                       )[0]?.status ===
                                                       "Notupdated"
                                                         ? ` `
                                                         : j?.shipServiceYears.filter(
                                                             (item) =>
                                                               item.year === i
                                                           )[0]?.status ===
                                                           "Updated"
                                                         ? `update-color`
                                                         : j?.shipServiceYears.filter(
                                                             (item) =>
                                                               item.year === i
                                                           )[0]?.status ===
                                                           "Overdue"
                                                         ? `Overdue-color`
                                                         : ``
                                                     }`}
                                                     aria-hidden="true"
                                                   ></i>
                                                 </OverlayTrigger>
                                                   <span className="text-right ml-3 d-none" id={"date"+i.split(" ")[0].replace(".","")}>
                                                   {j?.shipServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate !==null?
                                                        moment(j?.shipServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate).format("DD MMM YY"):""}
                                                 </span>
                                                </>
                                                ) : (
                                                   // </OverlayTrigger>
                                                   <>
                                                     <i
                                                       className="fa fa-times align-middle"
                                                       aria-hidden="true"
                                                       style={{
                                                         cursor: "default",
                                                       }}
                                                     ></i>
                                                   </>
                                                 )}
                                               </td>
                                             )
                                           )}
                                         </tr>
                                        </>))) : (<>
                                     <tr className="border-top">
                                       <td
                                         colSpan={11}
                                         className="text-center border-left border-bottom border-top border-right align-middle">
                                         <span className="spandoc-td">
                                           {" "}
                                           {t("EquipmentSeviceDetailsScreen.NoitemDisplay")}
                                       </span>
                                       </td>
                                     </tr>
                                   </>):
                                   /* if ship type is shore below table will display */
                                   !this.state.isShipType && this.state.isShoreType && !this.state.isBothType?
                                   Compliancetable?.equipments?.length !== 0 ? (Compliancetable?.equipments?.map(
                                       (j, index) => (
                                         <>
                                           <tr className="border-top">
                                             <td
                                               className={`${
                                                 window.innerWidth < 1000 ? ""
                                                   : "sl-no" }
                                               border-right border-left border-bottom text-center Service-equipment-width align-middle`} >
                                             <span className={`spandoc-td ${j?.inContract===true?"ContractColor":""}`}>
                                                 {j.equipmentName}
                                               </span>
                                             </td>
                                             <td
                                               className={`${
                                                 window.innerWidth < 1000
                                                   ? " "
                                                   : "Service-tr-title"
                                               }
                                               border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                               {" "}
                                               <span className="spandoc-td">
                                                 {j.quantity}
                                               </span>
                                             </td>
                                             <td
                                               className={`${
                                                 window.innerWidth < 1000
                                                   ? " "
                                                   : "Service-type-title"
                                               }
                                             border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                               <span className="spandoc-td">
                                               {t("Generateservicerequestcontent.Shore")}
                                               </span>
                                             </td>
                                             {ComplianceApplicableYears?.map(
                                               (i, index) => (
                                                 <td className="border-right text-center border-left border-bottom showdate">
                                                   {" "}
                                                   {j?.shoreServiceYears?.filter(
                                                     (item) => item?.year === i
                                                   )[0]?.year ? (
                                                     <>
                                                       <OverlayTrigger
                                                       placement="bottom" delay={{show: 250,hide: 400}}
                                                       overlay={this.renderPopoverTickShore(
                                                         j?.shoreServiceYears.filter((item) => item?.year === i)[0]?.year,
                                                         j,
                                                         "shore"
                                                       )}
                                                     > 
                                                     <i style={{cursor:"pointer"}}
                                                       className={`fa fa-check align-middle ${
                                                         j?.shoreServiceYears.filter(
                                                           (item) =>
                                                             item.year === i
                                                         )[0]?.status ===
                                                         "Notupdated"
                                                           ? ``
                                                           : j?.shoreServiceYears.filter(
                                                               (item) =>
                                                                 item.year === i
                                                             )[0]?.status ===
                                                             "Updated"
                                                           ? `update-color`
                                                           : j?.shoreServiceYears.filter(
                                                               (item) =>
                                                                 item.year === i
                                                             )[0]?.status ===
                                                             "Overdue"
                                                           ? `Overdue-color`
                                                           : ``}`}
                                                       aria-hidden="true"></i>
                                                       </OverlayTrigger>
                                                       <span className="text-right ml-3 d-none" id={"date"+i.split(" ")[0].replace(".","")}>
                                                       {j?.shoreServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate !==null? 
                                                       moment(j?.shoreServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate).format("DD MMM YY"):""}
                                                </span>
                                                </>
                                                   ) : (
                                                     //  </OverlayTrigger>
                                                     <>
                                                       <i
                                                         class="fa fa-times align-middle"
                                                         style={{
                                                           cursor: "default",
                                                         }}
                                                         aria-hidden="true"
                                                       ></i>
                                                     </>
                                                   )}
                                                 </td>
                                               )
                                             )}
                                           </tr></>))) : (<>
                                       <tr className="border-top">
                                         <td
                                           colSpan={11}
                                           className="text-center border-left border-bottom border-top border-right align-middle">
                                           <span className="spandoc-td">
                                             {" "}
                                             {t("EquipmentSeviceDetailsScreen.NoitemDisplay")}
                                         </span>
                                         </td>
                                       </tr>
                                     </>): this.state.isShipType && this.state.isShoreType && this.state.isBothType?
                                   Compliancetable?.equipments?.length !==0 ? (Compliancetable?.equipments?.map(
                                       (j, index) => (
                                         <>
                                           <tr className="border-top">
                                             <td
                                               className={`${
                                                 window.innerWidth < 1000 ? ""
                                                   : "sl-no" }
                                               border-right border-left border-bottom text-center Service-equipment-width align-middle`} >
                                              <span className={`spandoc-td ${j?.inContract===true?"ContractColor":""}`}>
                                                 {j.equipmentName}
                                               </span>
                                             </td>
                                             <td
                                               className={`${
                                                 window.innerWidth < 1000
                                                   ? " "
                                                   : "Service-tr-title"
                                               }
                                               border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                               {" "}
                                               <span className="spandoc-td">
                                                 {j.quantity}
                                               </span>
                                             </td>
                                             <td
                                               className={`${
                                                 window.innerWidth < 1000
                                                   ? " "
                                                   : "Service-type-title"
                                               }
                                             border-right border-left border-bottom text-center align-middle Service-type-width`}>
                                               <span className="spandoc-td">
                                               NA
                                               </span>
                                             </td>
                                             {ComplianceApplicableYears?.map(
                                               (i, index) => (
                                                 <td className="border-right text-center border-left border-bottom showdate">
                                                   {" "}
                                                   {j?.shoreServiceYears?.filter(
                                                     (item) => item?.year === i
                                                   )[0]?.year ? (
                                                     <>
                                                       <OverlayTrigger
                                                       placement="bottom" delay={{show: 250,hide: 400}}
                                                       overlay={this.renderPopoverTickShore(
                                                         j?.shoreServiceYears.filter((item) => item?.year === i)[0]?.year,
                                                         j,
                                                         "shore"
                                                       )}
                                                     > 
                                                     <i style={{cursor:"pointer"}}
                                                       className={`fa fa-check align-middle ${
                                                         j?.shoreServiceYears.filter(
                                                           (item) =>
                                                             item.year === i
                                                         )[0]?.status ===
                                                         "Notupdated"
                                                           ? ``
                                                           : j?.shoreServiceYears.filter(
                                                               (item) =>
                                                                 item.year === i
                                                             )[0]?.status ===
                                                             "Updated"
                                                           ? `update-color`
                                                           : j?.shoreServiceYears.filter(
                                                               (item) =>
                                                                 item.year === i
                                                             )[0]?.status ===
                                                             "Overdue"
                                                           ? `Overdue-color`
                                                           : ``}`}
                                                       aria-hidden="true"></i>
                                                       </OverlayTrigger>
                                                       <span className="text-right ml-3 d-none" id={"date"+i.split(" ")[0].replace(".","")}>
                                                         {j?.shoreServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate !==null?
                                                       moment(j?.shoreServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate).format("DD MMM YY"):""}
                                                </span>
                                                </>) : j?.shipServiceYears?.filter(
                                                   (item) => item?.year === i
                                                 )[0]?.year ? (
                                                   <>
                                                     <OverlayTrigger
                                                     placement="bottom"
                                                     delay={{
                                                       show: 250,
                                                       hide: 400,
                                                     }}
                                                     overlay={this.renderPopoverTick(
                                                       j?.shipServiceYears.filter((item) => item?.year === i)[0]?.year,
                                                       j,
                                                       "ship"
                                                     )}> 
                                                   <i style={{cursor:"pointer"}}
                                                     className={`fa fa-check align-middle text-left ${
                                                       j?.shipServiceYears.filter(
                                                         (item) =>
                                                           item.year === i
                                                       )[0]?.status ===
                                                       "Notupdated"
                                                         ? ` `
                                                         : j?.shipServiceYears.filter(
                                                             (item) =>
                                                               item.year === i
                                                           )[0]?.status ===
                                                           "Updated"
                                                         ? `update-color`
                                                         : j?.shipServiceYears.filter(
                                                             (item) =>
                                                               item.year === i
                                                           )[0]?.status ===
                                                           "Overdue"
                                                         ? `Overdue-color`
                                                         : ``
                                                     }`}
                                                     aria-hidden="true"
                                                   ></i>
                                                 </OverlayTrigger>
                                                   <span className="text-right ml-3 d-none" id={"date"+i.split(" ")[0].replace(".","")}>
                                                        {moment(j?.shipServiceYears?.filter((item) => item?.year === i)[0]?.nextDueDate).format("DD MMM YY")}
                                                 </span>
                                                </>
                                                ) :
                                                 (
                                                     //  </OverlayTrigger>
                                                     <>
                                                       <i
                                                         class="fa fa-times align-middle"
                                                         style={{
                                                           cursor: "default",
                                                         }}
                                                         aria-hidden="true"
                                                       ></i>
                                                     </>
                                                   )}
                                                 </td>
                                               )
                                             )}
                                           </tr></>))) : (<>
                                       <tr className="border-top">
                                         <td
                                           colSpan={11}
                                           className="text-center border-left border-bottom border-top border-right align-middle">
                                           <span className="spandoc-td">
                                             {" "}
                                             {t("EquipmentSeviceDetailsScreen.NoitemDisplay")}
                                         </span>
                                         </td>
                                       </tr>
                                     </>): <></>}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="pb-4 pl-4 pr-4 mt-2">
                        <div
                          className="search-btn-col"
                          style={{ textAlign: "end" }}>
                             <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-1"
                            type="submit"
                            onClick={() => this.ExportExcel(shipDetail.shipName,this.state.isContract,this.state.isNotContract,this.state.isbothContract)}
                          >
                            {" "}
                            {t("ComplianceandBudgetScreen.ExportExcel")}{" "}
                          </button>
                          </div>
                          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    shipDetail: state.ShipEquipmentReducer.ShipDetail || {},
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
    mmplHistorySearchResult:
      state.MMPLDashboardReducer.MMPLHistorySearchResult || null,
    applicableServiceType:
      state.MasterScreenReducer.applicableServiceTypeInterval,
    EquipmentZoneList: state.ShipEquipmentReducer.EquipmentZoneList,
    applicableServiceTypeBudget:
      state.MasterScreenReducer.applicableServiceTypeBudget,
    ContractPanelDetails: state.ShipEquipmentReducer.ContractPanelDetails,
    ShipEquipmentServiceYear:
      state.ShipEquipmentReducer.ShipEquipmentServiceYear,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(EquipmentUpdateListView));
